import React from 'react';
import TabbedNavigation from 'common/components/tabbed_navigation';
import { profileTabs } from 'header/ducks';

const ProfileHeaderTabs = ({ profile, user, router, location, params }) => {
  const isOwner = params.profileUsername === user.username;
  const hasEntries = !!user.image_entries_count || !!user.name_entries_count;

  /* all profiles have the 'Profile' tab */
  const links = [ profileTabs.links.find(link => link.name == 'Profile') ];

  /* only creative profiles have the 'Portfolio' tab */
  if (profile.is_creative) {
    links.push(profileTabs.links.find(link => link.name == 'Portfolio'));
  }

  /* only owners that have entries have the 'Your Entries' tab */
  if (isOwner && hasEntries) {
    links.push(profileTabs.links.find(link => link.name == 'Your Entries'));
  }

  return <TabbedNavigation router={router} tabs={{ links }}/>;
}

export default ProfileHeaderTabs;



// WEBPACK FOOTER //
// ./profile/components/header_tabs.jsx